// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1cWYm","obliqueLineWrap":"membershipbadge_obliqueLineWrap__11rOK","obliqueLine":"membershipbadge_obliqueLine__2RR4I"};